module.exports = __webpack_public_path__ + "static/media/homevideo.478aaf9b.svg";